
import React from "react";
import { Control } from "react-hook-form";
import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useTranslation } from "react-i18next";

// Updated to accept any control type to work with both create and edit forms
interface MaxClientsFieldProps {
  control: Control<any>;
}

const MaxClientsField: React.FC<MaxClientsFieldProps> = ({ control }) => {
  const { t } = useTranslation();

  return (
    <FormField
      control={control}
      name="maxClients"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('schedule.maxClients')}</FormLabel>
          <FormControl>
            <Input
              type="number"
              min="1"
              max="50"
              step="1"
              {...field}
              value={field.value || ''}
              onChange={(e) => {
                const value = e.target.value;
                // Convert to number, ensuring we don't lose precision
                const numValue = value === '' ? 0 : parseInt(value, 10);
                field.onChange(numValue);
              }}
              className="text-base"
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default MaxClientsField;
